import * as React from 'react';
import {
    Button,
    Control,
    Delete,
    Field,
    Icon,
    Input,
    Label,
    Modal,
    ModalBackground,
    ModalCard,
    ModalCardBody,
    ModalCardFooter,
    ModalCardHeader,
    ModalCardTitle
} from "bloomer";
import ErrorMessage from "../../../elements/ErrorMessage";
import {INVALID_FIELD_STYLE} from "../../../utils/Constants";

interface IAddEditFormProps {
    editing?: boolean;
    id?: number;
    name?: string;
    loading: boolean;
    errorMessage: string;
    onSave: any;
    onClose: any;
}

interface IAddEditFormState {
    editing: boolean;
    id: number;
    name: string;
    nameInvalid: boolean;
}

class AddEditForm extends React.Component<IAddEditFormProps, IAddEditFormState> {
    public constructor(props: IAddEditFormProps) {
        super(props);

        this.state = {
            editing: !!props.editing,
            id: props.id || null,
            name: props.name || "",
            nameInvalid: false
        };
    }

    public handleNameChange = (e: any) => {
        this.setState({
            name: e.target.value,
            nameInvalid: false
        });
    };

    public onSave = (e: any) => {
        e.target.blur();

        if (this.props.loading) {
            return;
        }

        if (!this.state.name.trim()) {
            this.setState({
                nameInvalid: true
            });
            return;
        }

        if (this.state.editing) {
            this.props.onSave(this.state.id, this.state.name.trim());
        } else {
            this.props.onSave(this.state.name.trim());
        }
    };

    public onClose = () => {
        this.props.onClose();
    };

    public render() {
        return <Modal isActive={true}>
            <ModalBackground style={{
                opacity: 0.5
            }}/>
            <ModalCard>
                <ModalCardHeader>
                    <ModalCardTitle>{this.state.editing ? 'Edit API Key' : 'Create New API Key'}</ModalCardTitle>
                    <Delete onClick={this.onClose}/>
                </ModalCardHeader>
                <ModalCardBody>
                    <Field>
                        <Label>Name</Label>
                        <Control>
                            <Input
                                style={this.state.nameInvalid ? INVALID_FIELD_STYLE : undefined}
                                type="text"
                                placeholder="API Key Name"
                                value={this.state.name}
                                onChange={this.handleNameChange}
                            />
                        </Control>
                    </Field>
                    {
                        this.props.errorMessage ? <ErrorMessage>{this.props.errorMessage}</ErrorMessage> : <></>
                    }
                </ModalCardBody>
                <ModalCardFooter>
                    {
                        this.props.loading ? <div style={{
                            textAlign: 'center'
                        }}>
                            <span>Loading...</span>
                            <Icon className="fas fa-spinner fa-spin"/>
                        </div> : <React.Fragment>
                            <Button onClick={this.onSave}>Save</Button>
                            <Button onClick={this.onClose}>Cancel</Button>
                        </React.Fragment>
                    }
                </ModalCardFooter>
            </ModalCard>
        </Modal>;
    }
}

export default AddEditForm;


// WEBPACK FOOTER //
// ./src/routes/APIKeys/AddEditForm/index.tsx